module.exports = __webpack_public_path__ + "static/media/arrow-right.6204fa2f.svg";